import * as React from 'react';
import { FC, useState } from 'react';
import { Alert, Form } from 'reactstrap';
import { SettingsItemContentProps } from '../SettingsItem';
import { PaymentsSettingsData } from '../../../models';
import { TextInputField, CheckInputField } from '../../../components/Forms/fields';
import { Row } from '../../../components/Forms/table/Row';
import { Col } from '../../../components/Forms/table/Column';
import { useTranslations } from '../../../store/translations/hooks';
import { TK } from '../../../store/translations/translationKeys';
import { Typography } from '@mui/material';
import EasypayCommissionsModal from './EasypayCommissionsModal';
import AppButton from '../../../components/AppButton';

export interface AutomaticPaymentsSettingsProps extends SettingsItemContentProps {
    values: PaymentsSettingsData,
    onChange: (settings: PaymentsSettingsData, save?: boolean) => void,
}

export const AutomaticPaymentsSettings : FC<AutomaticPaymentsSettingsProps> = ({
    id,
    values,
    onChange,
}) => {
    const t = useTranslations()
    const [commissionsOpen, setCommissionsOpen] = useState(false)

    return (
        <>
        <EasypayCommissionsModal isOpen={commissionsOpen} onClose={() => setCommissionsOpen(false)} />
        <Form style={{display: 'flex', marginTop: 'var(--spacer-S)', flexDirection: 'column', gap: 'var(--spacer-M)'}}>

            <Alert color="secondary" isOpen>
                {t(TK.automaticPaymentsSettingsDescription)}
            </Alert>

            <div style={{display: 'flex', flexDirection: 'column', gap: 'var(--spacer-XS)', marginBottom: 'var(--spacer-S)'}}>
                <AppButton color='success' block href='https://id.easypay.pt/signup?partnership=appointmint' target='_blank' rel='noopener noreferrer'>
                    {t(TK.createYourPaymentsAccount)}
                    <img style={{margin: 'var(--spacer-S)'}} src='https://www.easypay.pt/wp-content/uploads/logotipo-easypay.svg'/>
                </AppButton>
                <AppButton color='link' style={{alignSelf: 'flex-end'}} onClick={() => setCommissionsOpen(true)}>
                    {t(TK.viewEasypayCommissions)}
                </AppButton>
            </div>

            <Typography variant="subtitle2" gutterBottom>
                {t(TK.easypayPaymentAccountConfigNote)}
            </Typography>

            <Row>
                <Col md={6}>
                    <TextInputField
                        id={`${id}-payment-account`}
                        label={t(TK.paymentAccount)}
                        value={values.easypay?.paymentAccountId}
                        onChange={paymentAccountId => onChange({...values, easypay: {...values.easypay, paymentAccountId} as any})} />
                </Col>
            </Row>
            <Row>
                <Col md={6}>
                    <TextInputField
                        id={`${id}-api-account-id`}
                        label={t(TK.apiAccountId)}
                        helpText={t(TK.easypayApiConfigNote)}
                        value={values.easypay?.accountId}
                        onChange={accountId => onChange({...values, easypay: {...values.easypay, accountId} as any})} />
                </Col>
                <Col md={6}>
                    <TextInputField
                        id={`${id}-api-key`}
                        label={t(TK.apiKey)}
                        helpText={t(TK.easypayApiConfigNote)}
                        value={values.easypay?.apiKey}
                        type="text"
                        onChange={apiKey => onChange({...values, easypay: {...values.easypay, apiKey} as any})} />
                </Col>
            </Row>

            <Row>
                <Col md={6}>
                    <CheckInputField
                        id={`${id}-test-mode`}
                        label={t(TK.easypayTestMode)}
                        helpText={t(TK.easypayTestModeDescription)}
                        value={values.easypay?.testMode ?? true}
                        onChange={testMode => onChange({...values, easypay: {...values.easypay, testMode}})} />
                </Col>
            </Row>
        </Form>
        </>
    )
}
